var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{style:(_vm.darkmode ? _vm.$dark_theme : _vm.$light_theme)})
}
var staticRenderFns = []

export { render, staticRenderFns }